var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_37",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m55.02,17.04v3.44h-9.82v-3.44c0-.55.45-1,1-1h7.82c.56,0,1,.45,1,1Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m57.8,21.48v6.21c0,.55-.44,1-1,1h-13.38c-.55,0-1-.45-1-1v-6.21c0-.55.45-1,1-1h13.38c.56,0,1,.45,1,1Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m70.31,55.1v19.91c0,7.18-5.82,13-13,13h-14.4c-7.18,0-13-5.82-13-13v-19.91c0-9.46,6.5-17.4,15.29-19.59v-6.82h9.82v6.82c3.61.89,6.83,2.76,9.38,5.31,3.65,3.66,5.91,8.7,5.91,14.28Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }